import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { LogIn } from 'lucide-react';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      await login(username, password);
      toast.success('Erfolgreich eingeloggt!');
      navigate('/');
    } catch (error) {
      toast.error('Anmeldung fehlgeschlagen. Bitte überprüfen Sie Ihre Zugangsdaten.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-r from-blue-500 to-purple-600 mb-4">
              <LogIn className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-3xl font-bold text-gray-800 mb-2">Tasky</h1>
            <p className="text-gray-500">Melden Sie sich an, um fortzufahren</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="username" className="text-gray-700 font-medium">Benutzername</Label>
              <Input
                id="username"
                type="text"
                data-testid="login-username-input"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                className="mt-2 h-11"
                placeholder="Ihr Benutzername"
              />
            </div>

            <div>
              <Label htmlFor="password" className="text-gray-700 font-medium">Passwort</Label>
              <Input
                id="password"
                type="password"
                data-testid="login-password-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-2 h-11"
                placeholder="Ihr Passwort"
              />
            </div>

            <Button
              type="submit"
              data-testid="login-submit-button"
              disabled={isLoading}
              className="w-full h-11 bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white font-semibold"
            >
              {isLoading ? 'Anmeldung...' : 'Anmelden'}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <span className="text-gray-600">Noch kein Account? </span>
            <button
              onClick={() => navigate('/register')}
              className="text-blue-600 hover:text-blue-700 font-semibold"
            >
              Jetzt registrieren
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
